import { InjectionToken } from '@angular/core';

/**
 * Default PIN used for offline authentication when no user-specific PIN has been set. Provided at the shell level via
 * environment.defaultOfflinePin. Falls back to '1234' if not configured.
 */
export const DEFAULT_OFFLINE_PIN = new InjectionToken<string>('DEFAULT_OFFLINE_PIN', {
  providedIn: 'root',
  factory: () => '1234',
});

/** Offline session duration in hours. Configurable via environment.offlineSessionDurationHours. Defaults to 5 hours. */
export const OFFLINE_SESSION_DURATION_HOURS = new InjectionToken<number>('OFFLINE_SESSION_DURATION_HOURS', {
  providedIn: 'root',
  factory: () => 5,
});
